// Inline SVG data URL — used as onError fallback so images never render as
// broken chrome (which some browsers show as the URL/filename in text form).
// This tiny cream-coloured pizza-slice icon matches the site palette.
const FALLBACK_IMAGE =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(`
<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 400'>
  <rect width='400' height='400' fill='#F5EFE7'/>
  <g transform='translate(200 200)'>
    <circle r='90' fill='none' stroke='#C67C4E' stroke-width='4' opacity='0.5'/>
    <circle r='55' fill='none' stroke='#1B4332' stroke-width='2' opacity='0.3'/>
    <text x='0' y='6' font-family='Georgia,serif' font-size='28' font-style='italic' fill='#1B4332' text-anchor='middle' opacity='0.85'>La Pasteria</text>
  </g>
</svg>`);

/** Attach to any <img>: <img onError={handleImageError} ... /> */
export const handleImageError = (e) => {
  const img = e.currentTarget;
  if (img.dataset.fallbackApplied) return; // avoid infinite loop
  img.dataset.fallbackApplied = "true";
  img.src = FALLBACK_IMAGE;
  img.style.objectFit = "cover";
  img.alt = ""; // clear alt so browsers don't render the text on top of the fallback
};

export default handleImageError;
